const methods = {
  format: (situacaoAtividadeItem) => {
    if (situacaoAtividadeItem === 1) {
      return 'Não iniciada'
    } else if (situacaoAtividadeItem === 2) {
      return 'Em andamento'
    } else if (situacaoAtividadeItem === 3) {
      return 'Cumprida'
    } else if (situacaoAtividadeItem === 4) {
      return 'Cancelada'
    } else {
      return '-'
    }
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/utils/situacaoAtividade.js